module.exports = __webpack_public_path__ + "assets/685e5d53e45f03e8a77bc8d83a6d6b01.png";